import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, ListGroup, ListRow, MoneyField } from '@uplink/ui';
import { useEffect, useState } from 'react';
import { useTRPC } from '../api.ts';
import { haptic } from '../telegram.ts';

/** Выбор узлов, которые выдают платные и пробные VPN-ключи. */
export function AdminVpnSettingsScreen() {
  const trpc = useTRPC();
  const trialServers = useQuery(trpc.admin.vpnTrialServers.queryOptions());
  const sharedServers = useQuery(trpc.admin.vpnSharedServers.queryOptions());
  const [sharedPrice, setSharedPrice] = useState('4.99');
  useEffect(() => {
    if (sharedServers.data) setSharedPrice((sharedServers.data.priceMonthly / 100).toFixed(2));
  }, [sharedServers.data]);
  const selectTrialServer = useMutation(
    trpc.admin.selectVpnTrialServer.mutationOptions({
      onSuccess: async () => {
        await trialServers.refetch();
        haptic.success();
      },
      onError: () => haptic.error(),
    }),
  );
  const configureShared = useMutation(
    trpc.admin.configureSharedVpn.mutationOptions({
      onSuccess: async () => {
        await sharedServers.refetch();
        haptic.success();
      },
      onError: () => haptic.error(),
    }),
  );
  const priceCents = Math.round(Number(sharedPrice.replace(',', '.')) * 100);

  return (
    <main className="ul-screen">
      <h1 className="ul-screen__title">Настройки VPN</h1>

      <ListGroup
        header="VPN по подписке"
        footer="Используйте отдельный сервер: пробный узел выбрать нельзя. Клиент получает только свой ключ, без доступа к общей панели."
      >
        <MoneyField
          value={sharedPrice}
          onChange={(event) => setSharedPrice(event.target.value)}
          label="Цена общего VPN за 30 дней"
        />
        {sharedServers.data?.candidates.length ? (
          sharedServers.data.candidates.map((server) => (
            <ListRow
              key={server.id}
              icon={server.selected ? 'check' : 'server'}
              title={`${server.name} · ${server.location}`}
              subtitle={server.selected ? 'Этот сервер выдаёт платные ключи' : (server.ipv4 ?? '')}
              trailing={
                <Button
                  size="m"
                  disabled={configureShared.isPending || !Number.isSafeInteger(priceCents) || priceCents < 100}
                  onClick={() => configureShared.mutate({ serverId: server.id, priceMonthly: priceCents })}
                >
                  {server.selected ? 'Сохранить цену' : 'Выбрать'}
                </Button>
              }
            />
          ))
        ) : (
          <ListRow
            icon="alert"
            tone="crit"
            title="Нет отдельного сервера для подписок"
            subtitle="Создайте активный VLESS-сервер с доверенным сертификатом панели."
          />
        )}
      </ListGroup>

      <ListGroup header="Пробный VPN на 24 часа">
        {trialServers.data?.length ? (
          trialServers.data.map((server) => (
            <ListRow
              key={server.id}
              icon={server.selected ? 'check' : 'server'}
              title={`${server.name} · ${server.location}`}
              subtitle={server.selected ? 'Этот сервер выдаёт пробные ключи' : (server.ipv4 ?? '')}
              onClick={
                server.selected || selectTrialServer.isPending
                  ? undefined
                  : () => selectTrialServer.mutate({ serverId: server.id })
              }
            />
          ))
        ) : (
          <ListRow
            icon="alert"
            tone="crit"
            title="Нет подходящего сервера"
            subtitle="Нужен ваш активный сервер с готовым VLESS и доверенным сертификатом панели."
          />
        )}
      </ListGroup>
    </main>
  );
}
